// extracted by mini-css-extract-plugin
export default {"wrapper":"CtRveUGTtosX4iS5CW25","main_content":"PYnUtJMKAHqFV2WVEaK2","visible":"XZQQyJ3BPcec6NMCKwjf","invisible":"ybs222cSo1snG9u4otQX"};